export default __webpack_public_path__ + "static/17_34-9c6f1a56db829548e1ad24539f9d3eb9.png";